import styled from 'styled-components';
import MenuItem from '@/components/Menu/desktop/MenuItem';
import BottomRow from '@/components/Menu/shared/BottomRow';
import {useEffect, useMemo, useState} from 'react';
import {useIsDesktop} from '@repo/ui';
import {BREAKPOINTS, THEME_MODES} from "@repo/ui/themeSettings";
import {setSelectedItem} from "@/state/menuSlice";
import {usePathname} from "next/navigation";
import {useDispatch, useSelector} from "react-redux";
import {getCssSizeValue} from "@repo/utils";

const StyledWrapper = styled.div`
	display: none;
    @media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		display: flex;
		flex-direction: column;
		height: 100vh;
		justify-content: space-between;
		color: ${({ theme }) => (theme.mode === THEME_MODES.DARK ? theme.colors.white : theme.colors.twilightBlue)};
		padding-top: ${getCssSizeValue(160, BREAKPOINTS.DESKTOP)};
        padding-bottom: ${getCssSizeValue(70, BREAKPOINTS.DESKTOP)};
	}
`;

const DesktopContent = ({ data, globals }) => {
    const dispatch = useDispatch()
    const pathname = usePathname().split('/')[1];
    const isDesktop = useIsDesktop();
    const { selectedItem } = useSelector(state => state.menu);
    const menuItems = data?.menuItems || [];
    const listMenuItems = menuItems.slice(1, -1);
    const [activeItem, setActiveItem] = useState(-1);
    const firstMenuItem = menuItems[0]
    const lastMenuItem = menuItems[menuItems.length - 1]
    const [italicItem, setItalicItem] = useState(-1)

    const isChildIconVisible = useMemo(() => {
        return !(selectedItem === firstMenuItem || selectedItem === lastMenuItem);
    }, [selectedItem])

    useEffect(() => {
        menuItems.forEach((item, index) => {
            const slug = item?.link?.slug || ''
            // Edge case for home page, because on cms slug is 'home'
            if (pathname === '') {
                setItalicItem(item)
                setActiveItem(index)
                dispatch(setSelectedItem(item))
            }
            if (pathname === slug) {
                setItalicItem(item)
                setActiveItem(index - 1)
                dispatch(setSelectedItem(item));
            }

        } )
    }, [pathname, menuItems]);

    return (
        <StyledWrapper className="px-main">
            <div></div>
            <div>
                {listMenuItems.map((item, index) => (
                    <MenuItem
                        key={item?.id || index}
                        item={item}
                        activeItem={activeItem}
                        setActiveItem={setActiveItem}
                        index={index}
                        isChildIconVisible={isChildIconVisible}
                        italicItem={italicItem}
                        setItalicItem={setItalicItem}
                    />
                ))}
            </div>
            <BottomRow globals={globals} data={data} />
        </StyledWrapper>
    );
};

export default DesktopContent;